import React from 'react';
import {useDispatch, useSelector, useStore} from 'react-redux';
import './LeprechaunsMovementToolbar.css'
import {
  selectCurrentPlayer,
  selectPlayers,
  selectSelectedUnit
} from "../../../../../redux/reducers/sharedStateReducer/selectors";
import {LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT} from "../../../../../configs/factions/leprechauns";
import ModalButton from "../../../../Modals/ModalWindow/ModalButton/ModalButton";
import {getPlayerHexColor} from "../../../../../utils/players/getPlayerHexColor";
import FactionSkinIcon from '../../../../RankSkinFrame/FactionSkinIcon';
import {deselectUnit, leprechaunsStealCoins, showToast, withToastIcon} from "../../../../../redux/actions";
import {REGISTRY_SINGLETON} from "../../../../../scenes/Registry";
import {playLeprechaunsTheftEffects} from "../../../../../scenes/playAbilityCastEffects";
import {integerDivision} from "../../../../../utils/other/integerDivision";
import {checkIfLeprechaunsUnitCouldSteal} from "../../../../../utils/factions/checkIfLeprechaunsUnitCouldSteal";
import {getReadableInkColor} from '../../../../../utils/colors/getReadableInkColor';
import {StatWell} from '../../../../gameUi/StatWell';
import {MaskedIcon} from '../../../../coloredIcons/MaskedIcon/MaskedIcon';
import {getPlayerColorStyle} from '../../../../../utils/gameUi/getPlayerColorStyle';
import {TOAST_ICONS} from "../../../../../constants/toast";


const LeprechaunsMovementToolbar = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const selectedUnit = useSelector(selectSelectedUnit);
  const currentPlayer = useSelector(selectCurrentPlayer);
  const players = useSelector(selectPlayers);

  const otherPlayers = players.filter(player => player.id !== currentPlayer.id && player.coins > 0);

  if (!checkIfLeprechaunsUnitCouldSteal(selectedUnit, otherPlayers)) {
    return null
  }

  const stealCoins = (player, coinsToSteal) => {
    let coinsText = coinsToSteal === 1 ? 'монету' : 'монеты'
    const unitId = selectedUnit.id;
    dispatch(leprechaunsStealCoins(unitId, player.id, coinsToSteal));
    dispatch(withToastIcon(showToast(`Вы украли ${coinsToSteal} ${coinsText} у ${player.name}`, 'success', 3000, true, true), TOAST_ICONS.STEAL));
    dispatch(deselectUnit());
    // Звук кражи и «+N» украденных монет над отрядом-вором
    playLeprechaunsTheftEffects(store, REGISTRY_SINGLETON.getHexGridRenderer(), REGISTRY_SINGLETON.getSoundManager(), {
      unitId, coinsStolen: coinsToSteal,
    });
  }

  const canStealCoinsCount = integerDivision(selectedUnit.size, LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT);

  return (
    <div className={'leprechauns-movement-toolbar'}>
      {otherPlayers.map((player, index) => {
        const coinsToSteal = Math.min(player.coins, canStealCoinsCount);
        const buttonInk = getReadableInkColor(getPlayerHexColor(player.color));

        return (
          <div
            key={player.id}
            className={'leprechauns-movement-toolbar_player-info'}
            style={{...getPlayerColorStyle(player.color), '--row-index': index}}
          >
            <FactionSkinIcon
              imgClassName={'player-info_faction-icon'}
              factionId={player.factionId}
              skinId={player.selectedSkin}
              alt={player.factionId}
            />
            <div
              className={'leprechauns-movement-toolbar_player-name'}
              style={{
                color: getPlayerHexColor(player.color),
              }}
            >
              {player.name}
            </div>
            <StatWell
              icon={'/img/icons/coins.png'}
              value={player.coins}
              title={'Монеты игрока'}
              className={'leprechauns-movement-toolbar_coins'}
            />

            <ModalButton
              onClick={() => stealCoins(player, coinsToSteal)}
              className={'leprechauns-movement-toolbar_button'}
              noSound={true}
              style={{
                // background-color, не шорткат: фактура плиты кнопки — в
                // background-image (см. Footer.css)
                backgroundColor: getPlayerHexColor(player.color),
                color: buttonInk,
              }}
            >
              <h2 className={'leprechauns-movement-toolbar_steal-text'}>Украсть</h2>
              {/* На телефоне вместо подписи — рука: рядом с ником и монетами
                  слово не помещается */}
              <MaskedIcon
                className={'leprechauns-movement-toolbar_steal-icon'}
                src={'/img/icons/steal_hand.png'}
                alt={'Украсть'}
                title={'Украсть'}
                color={buttonInk}
              />
              {/* Сумма — в темном углублении: на кнопке цвета игрока (желтого,
                  оранжевого) золотая монета сливалась бы с фоном */}
              <StatWell
                icon={'/img/icons/coins.png'}
                value={coinsToSteal}
                title={'Монеты'}
                className={'leprechauns-movement-toolbar_steal-cost'}
              />
            </ModalButton>
          </div>
        )
      })}
    </div>
  );
};

export default LeprechaunsMovementToolbar;
